const compareObjects = <T extends Record<string, any>>(obj1: T, obj2: T): (keyof T)[] => {
	const differentKeys: (keyof T)[] = []
	const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)])
	allKeys.forEach(key => {
		if (obj1[key] !== obj2[key]) {
			differentKeys.push(key)
		}
	})

	return differentKeys
}

export const checkObjectsDifference = <T extends Record<string, any>>(obj1: T | null, obj2: T | null): (keyof T)[] => {
	if (!obj1 || !obj2) return []
	return compareObjects(obj1, obj2)
}

export const replaceObjectByID = (newObject: any, data: Ref<any[]>) => {
	const index = data.value.findIndex(d => d.id === newObject.id)
	if (index !== -1) {
		data.value[index] = newObject
	}
}

export const replaceObjectByUUID = (newObject: any, data: Ref<any[]>) => {
	const index = data.value.findIndex(d => d.uuid === newObject.uuid)
	if (index !== -1) {
		data.value[index] = newObject
	}
}

export const removeObjectByID = (objectToRemove: any, data: Ref<any[]>) => {
	const index = data.value.findIndex(d => d.id === objectToRemove.id)
	if (index !== -1) {
		data.value.splice(index, 1)
	}
}

export const generateSelectOptions = <T extends Record<string, string>>(
	selectEnum: T,
	selectMap: { [key in T[keyof T]]: string },
): IMultiSelectTypeOptions<T[keyof T]> =>
	Object.values(selectEnum).map(value => ({
		value: value as T[keyof T],
		label: convertValueName(selectMap, value as T[keyof T]),
	}))
